import { useMemo } from 'react';
import styled from 'styled-components';
import usePmStatuses from 'components/hooks/PM/usePmStatuses';
import { PM_STATES_CATEGORIES_NAMES_MAPPER } from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.constants';

const StyledSubOption = styled.div`
  margin-left: 2.5rem;
`;

const StyledCatOption = styled.div`
  font-weight: bold;
`;

const generateSubOption = pmStatus => ({
  value: pmStatus.value,
  placeholder: pmStatus.value,
  displayValue: <StyledSubOption>{pmStatus.value}</StyledSubOption>,
  searchableValue: pmStatus.search_value,
  pmStatus
});

const generateCatOption = categoryKey => ({
  value: categoryKey,
  displayValue: (
    <StyledCatOption>
      {PM_STATES_CATEGORIES_NAMES_MAPPER[categoryKey]}
    </StyledCatOption>
  ),
  searchableValue: PM_STATES_CATEGORIES_NAMES_MAPPER[categoryKey],
  isAlwaysVisible: true,
  pmStatus: {
    value: categoryKey,
    isCategory: true
  }
});

const generateCategoryOptions = (categoryKey, options) => [
  generateCatOption(categoryKey),
  ...options.map(generateSubOption)
];

const usePmStatusesOptions = () => {
  const pmStatuses = usePmStatuses();

  const generateOptions = () => {
    if (!pmStatuses || pmStatuses.length === 0) return [];

    const optionsByCategories = pmStatuses.reduce((acc, pmStatus) => {
      const categoryKey = pmStatus?.extra?.statusCategory?.key;
      return {
        ...acc,
        [categoryKey]: [...(acc[categoryKey] || []), pmStatus]
      };
    }, {});
    const options = Object.keys(optionsByCategories).reduce(
      (acc, categoryKey) => [
        ...acc,
        ...generateCategoryOptions(
          categoryKey,
          optionsByCategories[categoryKey]
        )
      ],
      []
    );
    return options;
  };

  const options = useMemo(generateOptions, [pmStatuses.length]);

  return options;
};

export default usePmStatusesOptions;
